<template>
	<svg
		:class="orientation"
		width="14"
		height="9"
		viewBox="0 0 14 9"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7 0.333291C7.17547 0.332276 7.34942 0.36591 7.51187 0.432263C7.67432 0.498616 7.82208 0.596382 7.94666 0.719957L13.28 6.05329C13.4043 6.17761 13.5029 6.32519 13.5702 6.48762C13.6375 6.65005 13.6721 6.82414 13.6721 6.99996C13.6721 7.17577 13.6375 7.34986 13.5702 7.51229C13.5029 7.67472 13.4043 7.82231 13.28 7.94662C13.1557 8.07094 13.0081 8.16956 12.8457 8.23684C12.6832 8.30412 12.5091 8.33875 12.3333 8.33875C12.1575 8.33875 11.9834 8.30412 11.821 8.23684C11.6586 8.16956 11.511 8.07094 11.3867 7.94662L7 3.53329L2.6 7.77329C2.47734 7.90968 2.32786 8.01929 2.16091 8.09527C1.99396 8.17125 1.81313 8.21197 1.62973 8.21487C1.44632 8.21778 1.26429 8.18281 1.09502 8.11216C0.925742 8.0415 0.772869 7.93668 0.645955 7.80425C0.51904 7.67182 0.420815 7.51462 0.357424 7.3425C0.294033 7.17037 0.26684 6.98702 0.277544 6.8039C0.288248 6.62079 0.33662 6.44185 0.419634 6.27828C0.502647 6.11471 0.618517 5.97003 0.759996 5.85329L6.09333 0.706624C6.33716 0.471537 6.66133 0.338058 7 0.333291Z"
			:fill="fill"
		/>
	</svg>
</template>
<style scoped lang="scss">
.right {
	transform: rotate(90deg);
}

.left {
	transform: rotate(270deg) translateX(2px);
}

.top {
}

.bottom {
	transform: rotate(180deg);
}
</style>
<script>
export default {
	name: 'IconChevron',
	props: {
		fill: {
			type: String,
			default: '#000',
		},
		orientation: {
			type: String,
			default: 'right',
		},
	},
}
</script>
